import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { CalendarToday, Add, Event } from '@mui/icons-material';

const ManualBookingPage = () => {
    return (
        <Box sx={{
            width: '100%',
            height: '100vh',
            bgcolor: '#121212',
            color: '#e0e0e0',
            pt: 8, // Account for fixed top menu bar
            overflow: 'auto'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
                px: 3 // Add padding to header
            }}>
                <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#ffffff' }}>
                    Manual Booking
                </Typography>

                <Button
                    variant="contained"
                    startIcon={<Add />}
                    sx={{
                        bgcolor: '#2196f3',
                        '&:hover': {
                            bgcolor: '#1976d2'
                        }
                    }}
                >
                    New Booking
                </Button>
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '60%',
                textAlign: 'center',
                px: 3 // Add padding to content
            }}>
                <CalendarToday sx={{ fontSize: 80, color: '#2196f3', mb: 2 }} />
                <Typography variant="h5" sx={{ mb: 2, color: '#ffffff' }}>
                    Manual Booking System
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, maxWidth: 600, color: '#b0b0b0' }}>
                    Create and manage manual bookings for your business. This feature allows you to
                    schedule appointments, reserve resources, and manage your booking calendar efficiently.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="contained"
                        startIcon={<Add />}
                        sx={{
                            bgcolor: '#2196f3',
                            '&:hover': {
                                bgcolor: '#1976d2'
                            }
                        }}
                    >
                        Create New Booking
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<Event />}
                        sx={{
                            borderColor: '#2196f3',
                            color: '#2196f3',
                            '&:hover': {
                                borderColor: '#1976d2',
                                bgcolor: 'rgba(33, 150, 243, 0.1)'
                            }
                        }}
                    >
                        View Calendar
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default ManualBookingPage;
